module.exports = __webpack_public_path__ + "static/media/4-vore.a4e126de.mp3";